import {
  useSelectFilterLogic,
  type UseSelectFilterLogicProps,
} from "~/GearboxSelectionAssistant/components/CharacteristicsFilter/components/useSelectFilterLogic";
import classNames from "classnames";
import classes from "~/GearboxSelectionAssistant/components/CharacteristicsFilter/components/RadioFilter.module.less";
import Checkbox from "~/common/components/Checkbox";

type Props = Omit<UseSelectFilterLogicProps, "multiselect"> & {
  className?: string;
  onChange: (code: string[]) => void;
  value: string[];
};

export const CheckboxFilter = ({ className, ...rest }: Props) => {
  const { name, items, makeOnClick, trackingCode } = useSelectFilterLogic({ ...rest, multiselect: true });

  return (
    <div className={classNames(className, classes.root)}>
      <label className={classes.name}>{name}</label>
      <ol className={classes.list} tracking-aux-section-marker={trackingCode}>
        {items.map((item, index) => (
          <li key={index} className={classes.listItem}>
            <Checkbox
              onClick={makeOnClick(item.code)}
              checked={rest.value.includes(item.code)}
              disabled={item.disabled}
              inputProps={{ "tracking-aux-option-marker": item.trackingCode }}
            />
            <label>{item.name}</label>
          </li>
        ))}
      </ol>
    </div>
  );
};
